import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadCrump, BreadCrumpItem } from '../../shared/bread-crump/bread-crump';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, BreadCrump],
  templateUrl: './contact-us.html',
  styleUrl: './contact-us.scss',
})
export class ContactUs implements OnInit, OnDestroy {
  form!: FormGroup;
  langSubscription!: Subscription;
  
  items: BreadCrumpItem[] = [];

  categoryList = [
    { id: 'suggestion', nameAr: 'اقتراح', nameEn: 'Suggestion' },
    { id: 'complaint', nameAr: 'شكوى', nameEn: 'Complaint' },
    { id: 'contact', nameAr: 'تواصل', nameEn: 'Contact' },
  ];

  constructor(private fb: FormBuilder, public translate: TranslateService) {}

  ngOnInit(): void {
    this.initForm();
    this.updateTranslations();
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  private updateTranslations() {
    this.items = [
      { label: this.translate.instant('Nav.Home'), url: '/' },
      { label: this.translate.instant('contact.title'), url: '/contact-us' },
    ];
  }

  private initForm() {
    const nameRegex = /^[\u0600-\u06FF\u0750-\u077Fa-zA-Z\s]{3,}$/;
    const phoneRegex = /^\+?[0-9]{7,15}$/;

    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern(nameRegex)]],
      lastName: ['', [Validators.required, Validators.pattern(nameRegex)]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneRegex)]],
      subject: [''],
      category: [''],
      messsage: [''],
      attachements: [null]
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      console.log('Form submitted', this.form.value);
      alert('تم إرسال رسالتك بنجاح. شكراً لتواصلك معنا.');
      this.form.reset();
    }
  }
}
